"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebContractListCollectionsResponseSchema = exports.WebContractGetCollectionsWithProductsResponseSchema = exports.WebContractCollectionIdPathParamsSchema = exports.WebContractListCollectionsQueryParamsSchema = void 0;
const zod_1 = require("zod");
const shared_1 = require("../../../shared");
const ProductCollectionSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    name: zod_1.z.string(),
    slug: zod_1.z.string(),
    image: zod_1.z.string().nullable(),
    videoUrl: zod_1.z.string().nullable(),
    shortDescription: zod_1.z.record(zod_1.z.string(), zod_1.z.string()).nullable(),
    description: zod_1.z.record(zod_1.z.string(), zod_1.z.string()).nullable(),
    rate: zod_1.z.number(),
});
const ProductDiscountSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    startDate: zod_1.z.coerce.date(),
    endDate: zod_1.z.coerce.date(),
    discountPrice: zod_1.z.number(),
    discountPriceUsd: zod_1.z.number(),
    productId: zod_1.z.string(),
});
const ProductSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    collectionId: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    deletedAt: zod_1.z.coerce.date().nullable(),
    restockedAt: zod_1.z.coerce.date().nullable(),
    name: zod_1.z.string(),
    slug: zod_1.z.string(),
    skuNo: zod_1.z.string(),
    coverImage: zod_1.z.string(),
    images: zod_1.z.string().array(),
    description: zod_1.z.record(zod_1.z.string(), zod_1.z.string()).nullable(),
    price: zod_1.z.number(),
    priceUsd: zod_1.z.number(),
    stock: zod_1.z.number().int(),
    isAvailable: zod_1.z.boolean(),
    frameShape: zod_1.z.string().nullable(),
    frameColor: zod_1.z.string().nullable(),
    lensColor: zod_1.z.string().nullable(),
    isPolarized: zod_1.z.boolean(),
});
exports.WebContractListCollectionsQueryParamsSchema = shared_1.ContractPaginationQueryParamsSchema;
exports.WebContractCollectionIdPathParamsSchema = zod_1.z.object({ collectionId: zod_1.z.string() });
exports.WebContractGetCollectionsWithProductsResponseSchema = zod_1.z.object({
    collection: ProductCollectionSchema.omit({
        createdAt: true,
        updatedAt: true,
    }).extend({
        createdAt: zod_1.z.string(),
        updatedAt: zod_1.z.string(),
        products: ProductSchema
            .omit({
            createdAt: true,
            updatedAt: true,
            deletedAt: true,
            restockedAt: true,
        })
            .extend({
            collectionName: zod_1.z.string(),
            collectionSlug: zod_1.z.string(),
            createdAt: zod_1.z.string(),
            updatedAt: zod_1.z.string(),
            deletedAt: zod_1.z.string().nullable(),
            restockedAt: zod_1.z.string().nullable(),
            discount: ProductDiscountSchema.omit({
                startDate: true,
                endDate: true,
            }).extend({
                startDate: zod_1.z.string(),
                endDate: zod_1.z.string(),
            }).nullable(),
        }).array(),
    }),
});
exports.WebContractListCollectionsResponseSchema = shared_1.ContractBaseListResponseSchema
    .extend({ collections: ProductCollectionSchema.array() });
